import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import Tooltip from '@mui/material/Tooltip';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import moment from "moment";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import {checkAuthentication} from '../../utils';


export default function EditRateDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const currencyRegEx = /^(?!0\.00)\d{1,3}(,\d{3})*(\.\d\d)?$/;

    const [sowChoices, setSowChoices] = React.useState([
        { label: "testSow 1", value: "test1" },
        { label: "testSow 2", value: "test2" }
    ])
    
    const [positionChoices, setPositionChoices] = React.useState([
        { label: 'Software Engineer', value: 'softwareEngineer' },
        { label: 'Test Engineer', value: 'testEngineer' }
    ]);

    const initialValues = {
        sowid: data.SOWID,
        position: data.PositionID,
        rate: parseFloat(data.Rate).toFixed(2)
    };

    const validFormSchema = Yup.object({
        sowid: Yup
            .string('Enter a SOWID to link to')
            .required('Linked SOWID is required'),
        position: Yup
            .string('Enter a position name')
            .required('Linked position is rquired'),
        rate: Yup.number().test(
            'is-Currency',
            'invalid Currency',
            value => (value + "").match(/^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{1})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/),
        )     
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            SOWID: values.sowid,
            PositionID: values.position,
            Rate: parseFloat(values.rate).toFixed(2)
        };

        handleEditCallback(msg);        
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const setChoicesSoW = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setSowChoices(choices)
    }

    const setChoicesPosition = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setPositionChoices(choices)
    }

    React.useEffect(() => {
		
		if (open){
		checkAuthentication();
		}
        if (refresh) {

            fetch('api/SOW', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoicesSoW(json))

            fetch('api/position', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoicesPosition(json))

            setRefresh(false);
        }
    })

    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit" placement="top-end">
                <IconButton variant="contained" onClick={handleClickOpen}>
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Edit Rate
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Rate Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-sowid">SOWID</InputLabel>
                                        <CustomSelect
                                            name="sowid"
                                            id="outlined-sowid"
                                            disabled
                                            options={sowChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.sowid}
                                            error={props.touched.sowid && Boolean(props.errors.sowid)}
                                            helperText={props.touched.sowid && props.errors.sowid}
                                            label="SOWID"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220  }}>
                                        <InputLabel htmlFor="outlined-position">Position</InputLabel>
                                        <CustomSelect
                                            name="position"
                                            id="outlined-position"
                                            disabled
                                            options={positionChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.position}
                                            error={props.touched.position && Boolean(props.errors.position)}
                                            helperText={props.touched.position && props.errors.position}
                                            label="Position"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 220  }}>
                                        <InputLabel htmlFor="outlined-rate">Rate</InputLabel>
                                        <OutlinedInput
                                            name="rate"
                                            id="outlined-rate"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.rate}
                                            error={props.touched.rate && Boolean(props.errors.rate)}
                                            helperText={props.touched.rate && props.errors.rate}
                                            label="Rate"
                                        />
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                
            </Dialog></MuiThemeProvider>
        </div>
    );
}